/* eslint-disable no-sequences */
import React from "react";
import Components from "mpm-components";
import { FormattedMessage } from "react-intl";
import { Form, Divider, Accordion, Icon, Button, Popup } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import Utilities from "mpm-config/Utilities";
import copy from "copy-to-clipboard";
import NumberFormat from "react-number-format";

export default ({
  cessionProduit,
  editMode,
}) => {
  const [activeIndex, setActiveIndex] = React.useState(0)
  const acquereur = cessionProduit.entreposage ? cessionProduit.entrepotCPDTO : cessionProduit.acquereurCPDTO;

  const handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps
    
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex)
  }

  return (
    cessionProduit && (
      <>
        <Components.Regions.RegionWithHeader
          title="menu.cession.capture"
          headerColor="blue"
          headerSize="small"
        >
          <Form>
            <Form.Group widths="equal">
              <Form.Input
                width="15"
                label="Numéro Cession "
                onChange={(event) => {}}
                value={cessionProduit.numeroCessionComplet}
                action={<Popup content='Copier' trigger={<Button icon onClick={() => copy(cessionProduit.numeroCessionComplet)}><Icon name="copy" /></Button>} /> }
              />

              <DateInput
                label="Date Système "
                type="text"
                name="dateSysteme"
                icon="calendar"
                disabled
                iconPosition="right"
                value={cessionProduit.dateSysteme}
                animation="fade"
                autoComplete="off"
                dateFormat="DD/MM/YYYY"
                onChange={undefined}
              />

              <DateInput
                label="Date Cession "
                type="text"
                name="dateCession"
                disabled
                icon="calendar"
                iconPosition="right"
                value={cessionProduit.dateCession}
                animation="fade"
                autoComplete="off"
                dateFormat="DD/MM/YYYY"
                onChange={undefined}
              />
            </Form.Group>
            <Divider /> 
        <Form.Group widths="equal" >
          <Form.Select
            label={ cessionProduit.entreposage ?
              "Type Entrepôt" :
              <FormattedMessage tagName="label" id="label.table.type-acquereur" />
            }
            disabled
            options={Utilities.getTypeAcquereurCPDropDownOptions()}
            required
            value={acquereur.typeAcquereur}
          />
           <Form.Input
              label={`${cessionProduit.entreposage ? "Numéro Entrepôt" : "Login Acquéreur"}`}
              required
              value={acquereur.numeroAcquereur}
              disabled
            />
            <Form.Field />
        </Form.Group>

        <Form.Group widths="equal">
           
            <Form.Input
              label={`${cessionProduit.entreposage ? "Prénom Entrepôt" : "Prénom Acquéreur"}`}
              value={acquereur.prenom}
              disabled
            />

            <Form.Input
              label={`${cessionProduit.entreposage ? "Nom Entrepôt" : "Nom Acquéreur"}`}
              value={acquereur.nom}
              disabled
            />
            <Form.Input
              label={`${cessionProduit.entreposage ? "Raison Sociale Entrepôt" : "Raison Sociale Acquéreur"}`}
              disabled
              value={acquereur.raisonSocialeFR}
            />
          </Form.Group>
        
      </Form>
        </Components.Regions.RegionWithHeader>

        <Components.Regions.RegionWithHeader
          title="label.sources"
          headerColor="blue"
          headerSize="small"
          striped={false}
        >
         <Accordion styled fluid> 
          {cessionProduit.childrenSourceCP &&
            cessionProduit.childrenSourceCP.map(
              (source, index) =>
                source.childrenSrcEsp &&
                source.childrenSrcEsp.filter((item) => item.selected).length >
                  0 && (
                    <span key={source.id}>
                    <Accordion.Title
                      active={activeIndex === index}
                      index={index}
                      onClick={handleAccordionClick}
                    >
                      <Icon name='dropdown' />
                      Source : 
                    {Utilities.getTypeSourceName(source.typeSource)} 
                    - {source.codeSource}
                    </Accordion.Title>
                    
                    <Accordion.Content active={activeIndex === index}>
                    <Components.Tables.SmartTable
                      header={[
                        {
                          selector: "refEspece.libelle",
                          label: "Espece",
                        },
                        {
                          selector: "quantite",
                          label: "Quantité cédée en (KG)",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.quantite} />
                        },
                        {
                          selector: "poidCD",
                          label: "Poids CD (KG)",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.poidCD} />
                       
                        },
                        {
                          selector: "rendementG",
                          textAlign: "center",
                          label: "Rendement G",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.rendementG} />

                        },
                        {
                          selector: "rendementT",
                          textAlign: "center",
                          label: "Rendement T",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.rendementT} />

                        },
                      ]}
                      data={
                        source.childrenSrcEsp
                          ? source.childrenSrcEsp.filter(
                              (item) => item.selected
                            )
                          : []
                      }
                      grouped={true}
                      groupeBy="refEspece.libelle"
                      groupeSums={["quantite", "poidCD"]}
                      rowsPerPage={5}
                      striped={true}
                      sortable={false}
                    />
                    </Accordion.Content>
                  </span>
                )
            )}
            </Accordion>
        </Components.Regions.RegionWithHeader>
      </>
    )
  );
};
